import { useState } from 'react';

import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

import { CreateEditDefectDialog } from './CreateEditDefectDialog';
import { DefectTypeSearchDialog } from './DefectTypeSearchDialog';

export const CreateDefectDialogs = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}) => {
  const { article } = useArticleContext();
  const [createdDefectId, setCreatedDefectId] = useState<string>();

  const createdDefect = article.snapshot.articleDefects.find((d) => d.id === createdDefectId);

  return (
    <>
      <DefectTypeSearchDialog
        isOpen={isOpen && !createdDefect}
        onClose={() => setIsOpen(false)}
        onDefectCreated={setCreatedDefectId}
      />
      <CreateEditDefectDialog
        isOpen={isOpen && !!createdDefect}
        setIsOpen={(newIsOpen) => {
          setIsOpen(newIsOpen);

          if (!newIsOpen) {
            setCreatedDefectId(undefined);
          }
        }}
        defect={createdDefect}
        mode="create"
      />
    </>
  );
};
